import { SettingsIcon as BaseSettingsIcon, Typography } from "@packages/ds";
import styled from "styled-components";

import UnstyledListGroup from "Components/ListGroup";
import Banner from "ds/Banner";
import { Layout as ButtonLayout } from "ds/Button";
import { breakpoints } from "Libs/theme";

export const MobileSettingsWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  justify-content: space-between;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`;

export const MobileSettingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  .more button.info-icon {
    svg path {
      fill: var(--menu-color-neutral-600-fill, var(--color-neutral-600));
    }
  }
`;

export const ListGroup = styled(UnstyledListGroup)`
  position: relative;
`;

export const ColumnWrapper = styled.div`
  @media (min-width: 600px) {
    > section {
      overflow: visible;
    }
  }
  @media (min-width: 900px) {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    > aside.col-4 {
      flex-grow: 1;
      margin-right: 32px;
      display: block;
      width: inherit;
      max-width: 437px;
      min-width: auto;
    }
    > div {
      flex-grow: 2;
      width: 63%;
      max-width: calc(100% - 464px);
      box-sizing: border-box;
    }
  }
`;

export const OverviewBlock = styled.div`
  padding: 32px;
  box-sizing: border-box;
`;

export const ServicesBlock = styled.div`
  height: max-content;

  > div {
    padding: 0 32px 52px;
    min-width: auto;
    width: auto;
  }
`;

export const Title = styled(Typography.Title)`
  padding: 24px 32px 32px !important;
`;

export const SettingsIcon = styled(BaseSettingsIcon)`
  margin-top: 4px;
  cursor: pointer;
  fill: var(--mode-vector-neutral-default);
`;

export const EnvMenuFlex = styled.div`
  display: flex;

  @media (min-width: 768px) {
    justify-content: flex-end;
  }
`;

export const BannerWrapper = styled(Banner)`
  ${ButtonLayout} {
    margin-left: unset;
  }
  justify-content: flex-start;
  margin-bottom: 32px;
  padding: 24px;
  position: relative;
  display: flex;
  flex-wrap: wrap;

  & > svg {
    width: 50px;
    height: 50px;
  }

  & > :last-child {
    top: 16px;
    right: 16px;
    svg path {
      fill: var(--mode-vector-neutral-default);
    }
  }

  @media (max-width: ${breakpoints[0]}) {
    align-items: flex-start;
  }
`;
export const BannerContent = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
  & > :last-child {
    color: var(--section-snow-color, var(--snow));
  }
  @media (max-width: ${breakpoints[0]}) {
    flex-direction: column;
    gap: 18px;
    & > :last-child {
      align-self: flex-start;
    }
  }
`;
export const BannerText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BannerTitle = styled(Typography.BodyText).attrs(() => ({
  weight: "semiBold"
}))``;

export const BannerDescription = styled(Typography.BodyText).attrs(() => ({
  size: "small"
}))`
  color: var(--banner-slate-color, var(--slate));
  @media (max-width: ${breakpoints[4]}) {
    max-width: 347px;
    white-space: normal;
    overflow: auto;
  }
`;
